<template>
	<div class="cp-news-hub">
		<p class="validation">Featured</p>
		<featured-article :articleId="articleId"/>
		<div class="cp-news-hub-container">
			<div :class="`cp-news-hub-grid-container item-${allNewsArticleCount}`">
				<a v-for="(article, index) in paginatedItems" :key="`news_${index}`" class="cp-news-hub-grid-inner-container" :href="article.url">
					<div class="news-image-container">
						<img class="news-image" :src="GetImageCropper(article.imageUrl)" />
					</div>
					
					<div class="news-text-container">
						<p class="news-date">{{ FormatDate(article.publishDate) }}</p>
						<h3 class="news-title">
							{{ article.title }}
							<p class="news-author">by {{ article.author }}</p>
						</h3>

						<p class="news-description">{{ article.description }}</p>
					</div>
				</a>
			</div>

			<div class="filter-projects-pagination-container" id="filter-projects-pagination-container" v-if="this.pageNumbers.length > 0 && allNewsArticles.length > this.itemsPerPage">
				<div class="cp-news-hub-pagination-d">
					<i
						class="bi bi-arrow-left filter-projects-pagination-arrow filter-projects-pagination-arrow-left"
						:class="{ 'filter-projects-pagination-arrow-disable': currentPage == 0 }"
						style="cursor:pointer;"
						v-on:click="
							prevPage();
							HandleEllipse();
							HandleArrows();
						"
					></i>

					<div
						class="cp-news-hub-nav-page-number"
						:class="{ 'page-number-active': currentPage == item, 'page-number-ellipse': item == '...' }"
						v-for="(item, index) in this.pageNumbersClone"
						:key="`pageNumber_${index}`"
						v-on:click="
							GoToPageNo(item);
							HandleEllipse();
							HandleArrows();
						"
					>
						<p>{{ item == "..." ? item : item + 1 }}</p>
					</div>
					<i
						v-on:click="
							nextPage();
							HandleEllipse();
							HandleArrows();
						"
						style="cursor:pointer;"
						class="bi bi-arrow-right filter-projects-pagination-arrow filter-projects-pagination-arrow-right"
						:class="{ 'filter-projects-pagination-arrow-disable': currentPage + 1 == pageCount }"
					>
					</i>
				</div>

				<div class="cp-news-hub-pagination-m">
					<i
						class="bi bi-arrow-left filter-projects-pagination-arrow filter-projects-pagination-arrow-left"
						:class="{ 'filter-projects-pagination-arrow-disable': currentPage == 0 }"
						style="cursor:pointer;"
						v-on:click="
							prevPage();
							HandleArrows();
						"
					></i>

					<p>Page {{ currentPage + 1 }} of {{ pageCount }}</p>

					<i
						v-on:click="
							nextPage();
							HandleEllipse();
							HandleArrows();
						"
						style="cursor:pointer;"
						class="bi bi-arrow-right filter-projects-pagination-arrow filter-projects-pagination-arrow-right"
						:class="{ 'filter-projects-pagination-arrow-disable': currentPage + 1 == pageCount }"
					>
					</i>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import FeaturedArticle from './featuredArticle.vue';
export default {
	props:{
		articleId: String
	},
	components: {FeaturedArticle},
	data() {
		return {
			allNewsArticles: [],
			paginate: ["sortedItems"],
			formattedDate: null,
			allNewsArticleCount: 0,
			currentPage: 0,
			lastPage: 0,
			itemsPerPage: this.CheckIfMobile(),
			pageCount: 0,
			pageNumbers: [],
			pageNumbersClone: [],
			pageLoaded: false,
		};
	},

	created() {
		axios.get("/api/NewsApi/GetAll").then((response) => {
			this.allNewsArticles = response.data;
			this.allNewsArticleCount = this.allNewsArticles.length;
			this.pageCount = Math.ceil(this.allNewsArticles.length / this.itemsPerPage);
			if (this.allNewsArticles != []) {
				this.pageLoaded = true;
			}

			this.pageNumbers = Array.from(Array(this.pageCount).keys());
			this.pageNumbersClone = [...this.pageNumbers];
			this.pageNumbersClone = this.pageNumbersClone.map(function(num) {
				return ++num;
			});

			this.HandleEllipse();
			this.HandleArrows();
		});
	},

	computed: {
		paginatedItems() {
			const startIndex = this.currentPage * this.itemsPerPage;
			const endIndex = startIndex + this.itemsPerPage;
			return this.allNewsArticles.slice(startIndex, endIndex);
		},

		pageCount() {
			return Math.ceil(this.allNewsArticles.length / this.itemsPerPage);
		},
	},

	methods: {
		FormatDate(date) {
			return moment(String(date)).format("DD MMM YY");
		},

		GetImageCropper(image) {
			if (image != null) {
				var value = 0;
				var newWidth = null;
				var newHeight = null;
				var cropLeft = 0.5;
				var cropTop = 0.5;

				if (window.screen.width <= 320) {
					value = window.screen.width / 320;
					newWidth = (value * 370).toFixed(0);
					newHeight = (value * 272).toFixed(0);
					return image + `?center=${cropTop},${cropLeft}&mode=crop&width=${newWidth}&height=${newHeight}&format=webp&quality=80&rnd=132945132427470000`;
				} else if (window.screen.width <= 767) {
					value = 2.8; //window.screen.width / 767;
					newWidth = (value * 370).toFixed(0);
					newHeight = (value * 272).toFixed(0);
					return image + `?center=${cropTop},${cropLeft}&mode=crop&width=${newWidth}&height=${newHeight}&format=webp&quality=80&rnd=132945132427470000`;
				} else if (window.screen.width <= 1279) {
					value = window.screen.width / 1279;
					newWidth = (value * 398).toFixed(0);
					newHeight = (value * 328).toFixed(0);
					return image + `?center=${cropTop},${cropLeft}&mode=crop&width=${newWidth}&height=${newHeight}&format=webp&quality=80&rnd=132945132427470000`;
				} else if (window.screen.width <= 1535) {
					value = window.screen.width / 1535;
					newWidth = (value * 440).toFixed(0);
					newHeight = (value * 328).toFixed(0);
					return image + `?center=${cropTop},${cropLeft}&mode=crop&width=${newWidth}&height=${newHeight}&format=webp&quality=80&rnd=132945132427470000`;
				} else if (window.screen.width <= 1920) {
					value = window.screen.width / 1920;
					newWidth = (value * 541).toFixed(0);
					newHeight = (value * 328).toFixed(0);
					return image + `?center=${cropTop},${cropLeft}&mode=crop&width=${newWidth}&height=${newHeight}&format=webp&quality=80&rnd=132945132427470000`;
				} else {
					value = window.screen.width / 1920;
					newWidth = (value * 619).toFixed(0);
					newHeight = (value * 392).toFixed(0);
					return image + `?center=${cropTop},${cropLeft}&mode=crop&width=${newWidth}&height=${newHeight}&format=webp&quality=80&rnd=132945132427470000`;
				}
			}
		},

		prevPage() {
			if (this.currentPage > 0) {
				this.currentPage--;
			}
		},

		nextPage() {
			if (this.currentPage < this.pageCount - 1) {
				this.currentPage++;
			}
		},

		GoToPageNo(n) {
			if (n != "...") {
				this.lastPage = this.currentPage;
				this.currentPage = n;
				window.scrollTo(0, 0);
			}
		},

		DisableElipses() {
			var pageNumberNodes = document.getElementsByClassName("cp-projects-page-nav-page-number");
			if (pageNumberNodes.length > 0);
			for (var i = 0; i < pageNumberNodes.length; i++) {
				pageNumberNodes[i].classList.remove("page-number-ellipse");

				if (pageNumberNodes[i].innerText == "...") {
					pageNumberNodes[i].classList.add("page-number-ellipse");
				}
			}
		},

		HandleEllipse() {
			this.pageNumbersClone = Array.from(Array(this.pageCount).keys());
			this.pageNumbersClone.map((x) => x + 1);

			if (this.pageCount > 6) {
				//FIRST 3 PAGES
				if (this.currentPage + 1 < this.pageCount - 4 && this.currentPage + 1 < 4) {
					this.pageNumbersClone.splice(4, this.pageCount - 5, "...").join();
				}
				//LAST 3 PAGES
				if (this.currentPage + 1 >= this.pageCount - 4 && this.currentPage + 1 > this.pageCount - 3) {
					this.pageNumbersClone.splice(1, this.pageCount - 5, "...").join();
				}
				//INBETWEEN PAGES
				if (!(this.currentPage + 1 < 4 || this.currentPage + 1 > this.pageCount - 3)) {
					this.pageNumbersClone.splice(1, this.pageCount - 5, "...").join();
					this.pageNumbersClone.splice(2, 1, this.currentPage - 1).join();
					this.pageNumbersClone.splice(3, 1, this.currentPage).join();
					this.pageNumbersClone.splice(4, 1, this.currentPage + 1).join();
					this.pageNumbersClone.splice(5, 0, "...").join();
				}
			}
		},

		HandleArrows() {
			window.scrollTo(0,300);
		},

		updatePageNumbers() {
			this.pageCount = Math.ceil(this.allNewsArticles.length / this.itemsPerPage);
			this.pageNumbers = Array.from(Array(this.pageCount).keys());
			this.pageNumbersClone = [...this.pageNumbers];
			this.pageNumbersClone = this.pageNumbersClone.map(function(num) {
				return ++num;
			});

			this.HandleEllipse();

			return this.pageNumbersClone;
		},

		CheckIfMobile(){
			if(window.innerWidth < 1600){
				return 6;
			} else {
				return 8;
			}
		}
	},
};
</script>
